import React, { Suspense } from 'react';
import { Grid, Row, Col } from '@vds/grids';
import PropTypes from 'prop-types';
import { Line } from '@vds/lines';

import Loader from '../../../common/Loader/index';
import {
  getSession,
  getFlowType,
  viewport,
  isMobile,
  isTablet,
  scrollToTop,
  isWHW,
  getCookie,
  printAgreement,
  checkIsMidnight,
  isFuncComp,
  isWHWP2,
  isWWM,
  isWHWPhase2Flag,
  isWHWP2TermFlag,
} from '../../../common/Helpers/index';
import TextLink from '../../../common/TextLink';
import AgreementCheckBox from './tosagreementCheckBox';
import { updateUrl } from '../../../common/Tagging/index';
import AgreementCBox from './agreementCheckBox';
import AgreementBox from './agreementBox';

import { mvaLinkApiCall } from '../../../common/MVAApiCall';
import { Body, Title } from '../../../common/Typography/index';
import MobileTos from './mobileTos';
import { getItemFromStore } from '../../../../utils/sessionStorage';
import { StyledVdsCol, StyledVdsRow } from '../../../common/styles';
import NotificationWrapper from '../../../common/Notification';

const type = viewport();
export default class TermsAndConditions extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      counter: 0,
      warningNotificationTitle: '',
    };
    this.props.updateTOSCheckBoxState({ terms: null, custAgree: null, custVHDP: null });
    this.props.completeOrderButtonClicked(false);
    this.props.enableButton(false);
  }

  componentDidMount() {
    const isNoSlotsAvailable = getSession('isNoSlotsAvailable');
    if (!isFuncComp() && ((this.props.reviewOrderState && !this.props.reviewOrderState.isSubmitSuccess) || isWHW() || isWHWP2())) {
      this.props.getAgreementDetails(isNoSlotsAvailable);
    }
    this.props.openTosMobile({
      isMobileTos: false,
      tosContent: '',
    });
    this.getCheckBoxTitle();
    this.setState({ warningNotificationTitle: '' });
  }

  getCheckBoxTitle = () => {
    const { tos } = this.props;
    const agreementTosList = [];
    let tosTypesList = '';
    const tosArray =
      tos?.agreementList && tos.agreementList.filter((i) => !(i.agreementType.indexOf('5GTerms') >= 0 || i.agreementType.indexOf('LTETerms') >= 0));
    const termsArray =
      tos?.agreementList && tos.agreementList.filter((i) => i.agreementType.indexOf('5GTerms') >= 0 || i.agreementType.indexOf('LTETerms') >= 0);

    if (termsArray && termsArray.length > 0 && tosArray && tosArray.length > 0) {
      agreementTosList.push(tosArray.concat(termsArray));
    }

    if (agreementTosList && agreementTosList.length > 0) {
      tosTypesList = agreementTosList[0] && agreementTosList[0].filter((i) => i.agreementType.indexOf('WHWTerms') >= 0);
    } else {
      tosTypesList = tos && tos.agreementList && tos.agreementList.filter((i) => i.agreementText && i.agreementText !== '');
    }

    const swapped =
      tosTypesList &&
      Object.fromEntries(
        // eslint-disable-next-line no-unused-vars
        Object.entries({ ...Object.keys(tosTypesList).map((list) => tosTypesList[list].agreementType) }).map(([k, v]) => [v, false]),
      );
    this.setState(swapped);
  };

  getCheckBoxContent = (contentType) => {
    const agreementTypes = [
      'customerAgreement',
      '5GTerms',
      'tradeInAgreement',
      'dpTCAgreement',
      'LTETerms',
      'eppTCAgreement',
      'verizonHomeDeviceProtectITTKAgreement',
    ];
    let content = '';
    const flowType = getFlowType() === 'LTE' ? 'LTE' : 'FiveG';
    let LQResponseData = getSession('LQResponse');
    LQResponseData = JSON.parse(LQResponseData);
    let stateCA = false;
    if (LQResponseData?.output?.state === 'CA') {
      stateCA = true;
    } else if ((isWHW() || isWHWP2()) && (viewport() === 'mfapp' ? getCookie('customerState') === 'CA' : getSession('customerState') === 'CA')) {
      stateCA = true;
    }
    const isCBandQualified = getSession('isCBandQual') === 'Y';
    if (checkIsMidnight()) {
      if (isCBandQualified && contentType === 'LTETerms') {
        const cbandagreementType = `${contentType}_cBand_Midnight`;
        content = this.props[cbandagreementType];
        if (content === undefined || content === null) {
          content = 'I have read and agree to the Verizon \u003Cu\u003E5G Home Internet Terms of Service\u003C/u\u003E';
        }
      } else if (agreementTypes.indexOf(contentType) >= 0) {
        let agreementType =
          contentType === 'customerAgreement' && isWHWPhase2Flag() && isWHWP2TermFlag()
            ? stateCA
              ? `${contentType}_${flowType}_WHWPhase2_CA`
              : `${contentType}_${flowType}_WHWPhase2`
            : stateCA
              ? `${contentType}_${flowType}_Midnight_CA`
              : `${contentType}_${flowType}_Midnight`;
        if (flowType === 'LTE' && contentType === '5GTerms') {
          agreementType = `LTETerms_${flowType}_Midnight`;
        }
        content = this.props[agreementType];
      } else if (contentType === 'WHWTerms') {
        content = stateCA ? `${this.props[`${contentType}_CA`]}` : `${this.props[contentType]}`;
      } else {
        content = this.props[contentType];
      }
    } else if (isCBandQualified && contentType === 'LTETerms') {
      const cbandagreementType = `${contentType}_cBand`;
      content = this.props[cbandagreementType];
      if (content === undefined || content === null) {
        content = 'I have read and agree to the Verizon \u003Cu\u003E5G Home Internet Terms of Service\u003C/u\u003E';
      }
    } else if (agreementTypes.indexOf(contentType) >= 0) {
      let agreementType = contentType === 'customerAgreement' && stateCA ? `${contentType}_${flowType}_CA` : `${contentType}_${flowType}`;
      if (flowType === 'LTE' && contentType === '5GTerms') {
        agreementType = `LTETerms_${flowType}`;
      }
      content = this.props[agreementType];
    } else if (contentType === 'WHWTerms') {
      content = stateCA ? `${this.props[`${contentType}_CA`]}` : `${this.props[contentType]}`;
    } else {
      content = this.props[contentType];
    }
    return content;
  };

  checkboxChecked = (e, id, tosTypes, dppTosText, contentTitle) => {
    // eslint-disable-next-line no-unused-expressions
    contentTitle && this.setState({ [contentTitle]: e.target.checked });
    const checkedtems = this.checkboxSelection(e);
    if (e.keyCode === 32 || e.keyCode === 13) {
      this.setState({
        counter: checkedtems,
      });
      console.log(
        'ALL THREE',
        checkedtems,
        tosTypes,
        checkedtems === (dppTosText !== undefined && dppTosText !== '' ? tosTypes.length + 1 : tosTypes.length),
      );
      this.props.enableButton(checkedtems === (dppTosText !== undefined && dppTosText !== '' ? tosTypes.length + 1 : tosTypes.length));
    } else if (dppTosText !== undefined && dppTosText !== '') {
      this.setState({
        counter: checkedtems,
      });
      // this.props.enableButton( enableButton: (checkedtems === tosTypes.length + 1));
      this.props.enableButton(checkedtems === tosTypes.length + 1);
    } else if (dppTosText === undefined || dppTosText === '') {
      this.setState({
        counter: checkedtems,
      });
      this.props.enableButton(checkedtems === tosTypes.length);
    }
  };

  checkboxSelection = (e) => {
    const { counter } = this.state;
    if (((e.keyCode === 32 || e.keyCode === 13) && e.target.checked) || (!e.keyCode && e.target.checked)) {
      return counter + 1;
    }
    return counter - 1;
  };

  learnMoreClick = (learnMoreLink) => {
    mvaLinkApiCall(learnMoreLink);
  };

  agreementType = (str) => {
    let agrType = str;
    if (str === '5GTerms' || str === 'LTETerms') {
      // Heading is same for LTE/cBand/MMV. For these 3 agrType agreementType will be 5GTerms
      if (isWHWPhase2Flag() && isWHWP2TermFlag()) {
        // eslint-disable-next-line no-param-reassign
        str = 'LTETerms_cBand_WHWPhase2';
      } else if (checkIsMidnight()) {
        // eslint-disable-next-line no-param-reassign
        str = 'LTETerms_cBand_Midnight';
      } else {
        // eslint-disable-next-line no-param-reassign
        str = 'LTETerms_cBand';
      }
    }
    const title = isWHWPhase2Flag() && isWHWP2TermFlag() && str !== 'WHWTerms' ? `${str}_Title_WHWPhase2` : `${str}_Title`;
    if (this.props[title]) {
      agrType = this.props[title];
    } else {
      agrType = str;
      if (str === 'customerAgreement') {
        agrType = isWHWPhase2Flag() && isWHWP2TermFlag() ? 'Verizon Customer Agreement' : str.charAt(0).toUpperCase() + str.slice(1); // first letter of customer Agreement should chnage to 'C'
      } else if (str === 'verizonHomeDeviceProtectITTKAgreement') {
        agrType = 'Verizon Home Device Protect';
      } else if (str === 'LTETerms_cBand' || str === 'LTETerms_cBand_WHWPhase2') {
        agrType = 'Verizon Home Internet (Wireless) Terms of Service';
      } else if (str === 'LTETerms_cBand_Midnight') {
        agrType = 'Terms of Service';
      }
    }
    updateUrl();
    return agrType;
  };

  printAgreementMobile = (tosContent) => {
    this.props.openTosMobile({
      isMobileTos: true,
      tosContent,
    });
    this.setState({ counter: 0 });
    this.props.enableButton(false);

    if (document.getElementById('videoCallBlock')) {
      document.getElementById('videoCallBlock').style.display = 'none';
    }
  };

  printTos = (tosContent) => {
    const deviceType = viewport();
    if (deviceType === 'mobile' || deviceType === 'mfapp') {
      this.printAgreementMobile(tosContent);
    } else {
      printAgreement(tosContent);
    }
  };

  closeMobileTos = () => {
    this.props.openTosMobile({
      isMobileTos: false,
      tosContent: null,
    });

    this.setState({ counter: this.getCounterLength() });
    if (this.getCheckBoxSelectionList().every(Boolean)) {
      this.props.enableButton(true);
    } else {
      this.props.enableButton(false);
    }

    if (document.getElementById('videoCallBlock')) {
      document.getElementById('videoCallBlock').style.display = 'inline-block';
    }
  };

  getCounterLength = () => this.getCheckBoxSelectionList().filter(Boolean).length;

  getCheckBoxSelectionList = () => {
    const checkboxSelectedList = Object.keys(this.state).map((key) => this.state[key] === true);
    checkboxSelectedList.shift();
    return checkboxSelectedList;
  };

  render() {
    const {
      tos,
      ownProps,
      dppTos,
      tosCheckBoxState,
      updateTOSCheckBoxState,
      completeOrderButtonClicked,
      isMobileTos,
      tosEnable,
      completeOrderButtonState,
    } = this.props;
    const agreementTos = [];
    let tosTypes = '';
    const errorState = this.props.appointmentScheduleState.errorSubmit;
    const show = getItemFromStore('show') || 'false';
    let showError = false;
    if (show === 'true' && errorState) {
      showError = true;
    } else if (show === 'false') {
      showError = false;
    }

    const tosArray =
      tos?.agreementList && tos.agreementList.filter((i) => !(i.agreementType.indexOf('5GTerms') >= 0 || i.agreementType.indexOf('LTETerms') >= 0));
    const termsArray =
      tos?.agreementList && tos.agreementList.filter((i) => i.agreementType.indexOf('5GTerms') >= 0 || i.agreementType.indexOf('LTETerms') >= 0);
    if (termsArray && termsArray.length > 0 && tosArray && tosArray.length > 0) {
      if (isWHWPhase2Flag() && isWHWP2TermFlag()) {
        agreementTos.push(tosArray.concat(termsArray));
      } else {
        agreementTos.push(termsArray.concat(tosArray));
      }
    }

    if (agreementTos && agreementTos.length > 0 && !(isWHW() || isWHWP2())) {
      tosTypes =
        agreementTos[0] &&
        agreementTos[0].filter((i) => i.agreementText && i.agreementText !== '' && i.agreementType && i.agreementType.indexOf('WHWTerms') !== 0);
    } else if (agreementTos && agreementTos.length > 0 && (isWHW() || isWHWP2())) {
      tosTypes = agreementTos?.[0]?.filter((i) => i.agreementType.indexOf('WHWTerms') >= 0);
    } else {
      tosTypes = tos && tos.agreementList && tos.agreementList.filter((i) => i.agreementText && i.agreementText !== '');
    }
    if (tosTypes?.length > 1) {
      const vhdpindex = tosTypes.findIndex((item) => item.agreementType === 'verizonHomeDeviceProtectITTKAgreement');

      if (vhdpindex !== -1) {
        const vhpdTerms = tosTypes.splice(vhdpindex, 1)[0];
        if (tosTypes) {
          tosTypes.unshift(vhpdTerms);
        }
      }
    }

    if (!checkIsMidnight() && tosTypes?.length >= 0) {
      tosTypes = tosTypes?.filter((i) => !i.agreementType.includes('verizonHomeDeviceProtectITTKAgreement'));
    }
    if (isWWM() && tosTypes?.length >= 0) {
      tosTypes = tosTypes?.filter((i) => i.agreementType.indexOf('5GTerms') >= 0);
    }

    const dppTosText =
      dppTos?.installmentContractsList && dppTos.installmentContractsList[0] && dppTos.installmentContractsList[0].installmentContractDetailHTML;

    const MobileTerms = <MobileTos content={this.props.tosContent} onClose={this.closeMobileTos} />;

    if (showError) {
      scrollToTop();
    }

    const setWarningNotificationTitle = () => {
      if (completeOrderButtonState) {
        if (tosCheckBoxState.terms === false && tosCheckBoxState.custAgree === false) {
          this.setState({ warningNotificationTitle: 'Please accept Terms of Services and Customer Agreement to proceed.' });
        } else if (tosCheckBoxState.terms === false && tosCheckBoxState.custAgree === true) {
          this.setState({ warningNotificationTitle: 'Please accept Terms of Services to proceed.' });
        } else if (tosCheckBoxState.terms === true && tosCheckBoxState.custAgree === false) {
          this.setState({ warningNotificationTitle: 'Please accept Customer Agreement to proceed.' });
          return true;
        }
      }
      if ((tosCheckBoxState.terms === true && tosCheckBoxState.custAgree === true) || !this.state.warningNotificationTitle) return false;
      return true;
    };

    const notificationProps = {
      title: this.state.warningNotificationTitle,
      type: 'warning',
      hideCloseButton: true,
      pageName: 'tosIndex',
    };

    return (
      <div id="tosContainerWrapper">
        {this.props.isMobileTos === true ? (
          MobileTerms
        ) : (
          <>
            <Suspense fallback={<Loader active />}>
              <div className="onlyBottomBorder noPadding" style={{ marginTop: isTablet() ? '20px' : '' }}>
                <Title bold={false} size="large">
                  {ownProps.tosHeading}
                </Title>
                {isWWM() && (
                  <Body primitive="p" size="large">
                    <div className="tosLinks">
                      <br />
                      {ownProps.tosSubHeadingWWM}
                    </div>
                  </Body>
                )}
                {setWarningNotificationTitle() &&
                  !isMobileTos &&
                  !tosEnable &&
                  (tosCheckBoxState.terms === false || tosCheckBoxState.custAgree === false) && (
                    <StyledVdsRow mTop="16px">
                      <NotificationWrapper {...notificationProps} />
                    </StyledVdsRow>
                  )}
              </div>
              <iframe title="Print" id="printFrame" className="clear" aria-hidden="true" tabIndex="-1" />
              {tosTypes &&
                tosTypes.map((item, index) => (
                  <Row className="noPadding checkboxWrapper">
                    <StyledVdsCol colSizes={{ desktop: 10, tablet: 4, mobile: 4 }}>
                      <div style={{ width: isMobile() ? '100%' : '600px', marginTop: isMobile() ? '24px' : '38px' }}>
                        <Title primitive="h4" size={type !== 'mobile' && type !== 'mfapp' ? 'medium' : 'small'} bold>
                          {this.agreementType(item.agreementType)}
                        </Title>
                      </div>
                      <AgreementCheckBox
                        name={item.agreementType}
                        content={this.getCheckBoxContent(item.agreementType)}
                        id={`tosAgree${index}`}
                        change={(e, id, contentTitle) => this.checkboxChecked(e, id, tosTypes, dppTosText, contentTitle)}
                        agreementText={item.agreementText}
                        ariaLabel={item.agreementType}
                        selected={this.state[item.agreementType]}
                        contentTitle={item.agreementType}
                        tosTypes={tosTypes}
                        index={index}
                        tosCheckBoxState={tosCheckBoxState}
                        updateTOSCheckBoxState={updateTOSCheckBoxState}
                        completeOrderButtonClicked={completeOrderButtonClicked}
                      />
                    </StyledVdsCol>
                    {item.agreementText && (
                      <StyledVdsCol
                        colSizes={{ desktop: 2, tablet: 4, mobile: 4 }}
                        mTop={isMobile() ? '10px' : isTablet() ? '10px' : '5%'}
                        pLeft={isMobile() ? '42px' : isTablet() ? '38px' : ''}
                        display="inline-block"
                        width="5%"
                        verticalAlign="top"
                      >
                        <TextLink
                          role="button"
                          onClick={() => {
                            this.printTos(item.agreementText);
                            setTimeout(() => {
                              document.getElementById(`print-focusid${index}`).focus();
                            }, 100);
                          }}
                          size="large"
                          id={`print-focusid${index}`}
                          analyticstrack="5G-printAgreement"
                          ariaLabel={`Print ${this.agreementType(item.agreementType)}`}
                          data-track
                        >
                          <Body style={{ paddingLeft: '50px' }} primitive="span" size="large">
                            Print
                          </Body>
                        </TextLink>
                      </StyledVdsCol>
                    )}
                  </Row>
                ))}
              {dppTosText && (
                <section className="redesignOrderReviewContainer">
                  <Grid className="marginBottom20 dppMarginLeft">
                    <Row>
                      <Col className="marginTop10" colSizes={{ desktop: 12, tablet: 12, mobile: 4 }}>
                        <Line type="secondary" surface="light" />
                      </Col>
                      <Col className="contains-PII" data-cs-mask colSizes={{ desktop: 12, tablet: 12, mobile: 4 }}>
                        <iframe title="Print" id="printFrame" className="clear" aria-hidden="true" tabIndex="-1" />
                        <h1>Device Payment Agreement</h1>
                        <h2>You must read and scroll through entire Device Payment Plan agreement</h2>
                        <AgreementBox content={dppTosText} id="DPPAgreement" />
                        <AgreementCBox
                          name="dppTosAgree"
                          content={this.props.edgeTermsAndCondition}
                          textId="DPPAgreement"
                          id="dppTos"
                          change={(e, id) => this.checkboxChecked(e, id, tosTypes, dppTosText)}
                        />
                        <button
                          className="fontSize_3 link background_transparent displayInlineBlock borderSize_0 secondary"
                          type="button"
                          id="dppTosFocusId"
                          onClick={() => {
                            this.printTos(dppTosText);
                            setTimeout(() => {
                              document.getElementById('dppTosFocusId').focus();
                            }, 100);
                          }}
                          data-track
                        >
                          <Body primitive="span" size="large">
                            Print
                          </Body>
                        </button>
                      </Col>
                    </Row>
                  </Grid>
                </section>
              )}

              {this.props.autoPayText && this.props.autoPayText !== '' && (
                <p className="pad12 onlyTopPad fontSize_2 marginRight16">{this.props.autoPayText}</p>
              )}
            </Suspense>
          </>
        )}
      </div>
    );
  }
}

TermsAndConditions.propTypes = {
  tos: PropTypes.any,
  getAgreementDetails: PropTypes.func,
  ownProps: PropTypes.any,
  dppTos: PropTypes.any,
  edgeTermsAndCondition: PropTypes.string,
  // state: PropTypes.string,
  autoPayText: PropTypes.string,
  // mva_learnMoreUrl_prop_65: PropTypes.string,
  appointmentScheduleState: PropTypes.any,
  openTosMobile: PropTypes.func,
  isMobileTos: PropTypes.bool,
  tosContent: PropTypes.string,
  reviewOrderState: PropTypes.object,
  // disclaimerText_mva: PropTypes.string,
  enableButton: PropTypes.func,
  tosCheckBoxState: PropTypes.object,
  updateTOSCheckBoxState: PropTypes.func,
  completeOrderButtonClicked: PropTypes.func,
  tosEnable: PropTypes.bool,
  completeOrderButtonState: PropTypes.bool,
};

// TermsAndConditions.defaultProps = {
//   mva_learnMoreUrl_prop_65: 'https://www.verizon.com/about/news/covid-response-customers',
//   disclaimerText_mva:
//     'Proposition 65 requires businesses to provide warnings to Californians about significant exposures to chemicals that cause cancer, birth defects or other reproductive harm. These chemicals can be in the products that Californians purchase, in their homes or workplaces, or that are released into the environment. By requiring that this information be provided, Proposition 65 enables Californians to make informed decisions about their exposures to these chemicals.',
// };
